import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostImportCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostImportCommandService],
  exports: []
})
export class PostImportCommandServiceModule { }
